import { capitalize } from "lodash";

import { LabOrder } from "pwapi";

export function splitFlagReason(reason: string): string {
  return reason
    .split("-")
    .map((s) => capitalize(s))
    .join(" ");
}

const noChargeReasonLabels = {
  "stain-not-optimal": "Stain not technically optimal",
  academic: "Stain performed for academic purposes",
  noncontributory: "Stain noncontributory",
  "ordered-error": "Stain ordered in error",
  "incorrect-stain": "Incorrect stain",
  "processing-not-optimal": "Processing not technically optimal",
};
export const noChargeReasonEnumToLabel = (
  shortEnum: LabOrder.no_charge_reason
) => {
  return (shortEnum && noChargeReasonLabels[shortEnum]) || shortEnum;
};
